import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})

export class DateFormatPipe implements PipeTransform {

  transform(value: string, type: string = '', args: string): string {
    try {
      const dd = value.substr(8, 2);
      const MM = value.substr(5, 2);
      const yyyy = value.substr(0, 4);
      const date = `${dd}/${MM}/${yyyy}`;

      let time = '';


      if (type != 'short') {
        const hh = value.substr(11, 2);
        const mm = value.substr(14, 2);
        const ss = value.substr(17, 2);
        time = `${hh}:${mm}`;
      }

      if (args === 'yyyy') {
        return `${yyyy}`;
      } else if (args === 'dd/MM/yyyy') {
        return `${dd}/${MM}/${yyyy}`;
      } else {
        return `${date} ${time}`;
      }

    } catch (err) {
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/resources/pipes/date-format.pipe.ts